import React, { memo } from 'react';
import { FBConnector } from './FBConnector';
import { usePages } from '../PagesProvider';
export var PagesConnector = memo(function () {
    var dispatchPages = usePages().dispatchPages;
    return (React.createElement(FBConnector, { dispatch: dispatchPages }));
});
